import { createContext, useContext, useState } from "react";

/**
 * The transition types of the navigation that brought the current location.
 *
 * `TransitionTypeRouter` provides it out of the same state update as the
 * location, so a page rendering for the first time reads the types of the
 * navigation that opened it and never the one before. Empty outside that router
 * and on the first render, where no navigation has happened.
 */
export const NavigationTransitionTypesContext = createContext<readonly string[]>([]);

/**
 * Whether the navigation that opened this page carried a transition type.
 *
 * Answered once, when the page mounts. A page that stays where it is while its
 * address changes — a search parameter, say — is still the page that
 * navigation opened, and an answer that changed under it would start an
 * entrance on a page already on screen.
 */
export const useArrivedWithTransitionType = (type: string) => {
  const types = useContext(NavigationTransitionTypesContext);
  const [arrivedWithType] = useState(() => types.includes(type));

  return arrivedWithType;
};
